export default [
    {
        key: 'article',
        label: '相关新闻'
    },
    {
        key: 'topic',
        label: '相关话题'
    },
    {
        key: 'activity',
        label: '相关活动'
    }
]
